var render = function render(){var _vm=this,_c=_vm._self._c;return _c('symbol',{attrs:{"id":`${_vm.prefix}arrow_corner-24`,"viewBox":"0 0 24 24"}},[_c('circle',{staticClass:"base",attrs:{"cx":"12","cy":"12","r":"12"}}),_c('path',{staticClass:"sign arrow",attrs:{"d":"M11.9497 15.3638L8 11.4141L9.41406 10L11.9497 12.5356L14.4849 10L15.8989 11.4141L11.9497 15.3638Z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }